import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

/**
 * ProtectedRoute
 * Wraps pages that require a logged-in user.
 * If not logged in, redirects to /login and remembers where they were
 * going so we can redirect back after login.
 */
export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: 'var(--brand-paper)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center' }}>
          <span style={{ fontSize: 36, display: 'block', marginBottom: 'var(--space-md)' }}>📖</span>
          <p style={{ fontSize: 'var(--font-size-md)', color: 'var(--neutral-400)', fontFamily: 'var(--font-display)' }}>Loading your library...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    // Save where they were going so we can redirect after login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
